// @flow
export const valueReducer = (initialState: any, setValueAction: string) => (state: any = initialState, action: Object) => {
  switch (action.type) {
    case setValueAction:
      return action.payload;
    default:
      return state;
  }
};